$(document).ready(function () {
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0
        || navigator.platform.toUpperCase().indexOf('IPAD') >= 0
        || navigator.platform.toUpperCase().indexOf('IPHONE') >= 0) {
        $('body').addClass('apple--device')
    }
});

